import src from "IMAGE";
export default { src, width: 381, height: 96, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARElEQVR42i3GsQqAIBAGYLm75eYgi2yVoKJEUFBw8v2fyX9w+OAzqdS2rNaLyMvMN3zwg4fHpBz76VxQ1YuINtjhmLcDvd0E2I0C4KcAAAAASUVORK5CYII="};
